// @i18n-ignore-file
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable i18next/no-literal-string */
import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { CONFIG_BUILD_ENV, CONFIG_AUTH_ENDPOINT } from '@src/config/env'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import amplifyProdConfig from './aws-exports-prod.json'
import amplifyQAConfig from './aws-exports-qa.json'
import amplifyStageConfig from './aws-exports-staging.json'

function getEnvAmplifyConfig() {
  switch (CONFIG_BUILD_ENV) {
    case BUILD_ENVIRONMENTS.DEV:
    case BUILD_ENVIRONMENTS.STAGE:
      return amplifyStageConfig
    case BUILD_ENVIRONMENTS.QA:
    case BUILD_ENVIRONMENTS.FEATURE_PREVIEW:
    case BUILD_ENVIRONMENTS.AUTO_PREVIEW:
      return amplifyQAConfig
    case BUILD_ENVIRONMENTS.PROD:
    default:
      return amplifyProdConfig
  }
}

export default function getAmplifyConfig() {
  if (!isBrowser()) return

  const envConfig = getEnvAmplifyConfig()

  // Simple setup - just 3 required fields!
  return {
    userPoolId: envConfig.aws_user_pools_id,
    userPoolClientId: envConfig.aws_user_pools_web_client_id,
    region: envConfig.aws_cognito_region,
    authFlowType: 'USER_PASSWORD_AUTH',
    apiEndpoints: envConfig.aws_cloud_logic_custom,

    // Add Google OAuth - clear and obvious
    oauth: {
      domain: CONFIG_AUTH_ENDPOINT,
      scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: [`${location.origin}/log-in`],
      redirectSignOut: [location.origin],
      responseType: 'code',
      providers: ['Google'],
    },

    ssr: true,
  }
}
